import { MINUTES_PER_DAY, sessionMinutes } from './clinic-day';
export const CLINIC_SLOT_MINUTES = 10;
const MINUTES_PER_WEEK = MINUTES_PER_DAY * 7;
const WEEK_SHIFTS = [-MINUTES_PER_WEEK, 0, MINUTES_PER_WEEK];
function weekSpan(period) {
    const { start, end } = sessionMinutes(period.startTime, period.endTime);
    const offset = period.weekday * MINUTES_PER_DAY;
    return { from: offset + start, to: offset + end };
}
function spansCollide(a, b) {
    return WEEK_SHIFTS.some((shift) => a.from < b.to + shift && b.from + shift < a.to);
}
export function periodsCollide(a, b) {
    return spansCollide(weekSpan(a), weekSpan(b));
}
export function findOverlapBetween(left, right) {
    for (const a of left) {
        for (const b of right) {
            if (periodsCollide(a, b))
                return { left: a, right: b };
        }
    }
    return null;
}
export function findOverlapWithin(periods) {
    const ordered = [...periods].sort((a, b) => weekSpan(a).from - weekSpan(b).from);
    for (let i = 0; i < ordered.length; i += 1) {
        for (let j = i + 1; j < ordered.length; j += 1) {
            if (periodsCollide(ordered[i], ordered[j]))
                return { first: ordered[i], second: ordered[j] };
        }
    }
    return null;
}
//# sourceMappingURL=schedule-periods.js.map